(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('admin-configuration', {
            parent: 'account',
            url: '/admin-configuration',
            data: {
                authorities: ['PERM_USER_ADMIN'],
                pageTitle: 'global.menu.account.admin.configuration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/admin-configuration/admin-configuration.html',
                    controller: 'AdminConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('client');
                    $translatePartialLoader.addPart('users');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
